import { isBlank } from "../../utils/taxWithheld";

export const MODE_OPTIONS = [
  { label: "None", value: "NONE" },
  { label: "Cash", value: "CASH" },
  { label: "Invested", value: "INVESTED" },
];
export const INVESTED_HELPER =
  "Saveback is recorded when you save the buy it funds.";
export const RATE_RULES = {
  required: "Rate is required",
  min: { value: 0, message: "Rate cannot be negative" },
  max: { value: 100, message: "Rate cannot exceed 100%" },
  validate: (value: unknown) =>
    /^\d+(\.\d{1,6})?$/.test(String(value)) || "Use up to 6 decimal places",
};
export const CAP_RULES = {
  min: { value: 0, message: "Cap cannot be negative" },
  validate: (value?: string | number | null) =>
    isBlank(value) ||
    /^\d+(\.\d{1,2})?$/.test(String(value)) ||
    "Use up to 2 decimal places",
};
